import React, { useContext, useState } from "react";
import logo from "../src/assets/images/2 (2) (1).png";
import { ContactUsModal } from "./ContactUsModal";
import { PatentContext } from "./context/PatentContextProvider";
import { TbSend } from "react-icons/tb";
import { IoNewspaperOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import BBBlogo from "./assets/images/footerlogo (1).png";
import genevieveInAction from "./assets/video/IMG_7745.mp4";
import jeevesInAction from "./assets/video/IMG_7756.mp4";
import GeoInAction from "./assets/video/IMG_7777.mp4";
import VMI from "./assets/video/VMI.mp4";
import EmergencyVideo from "./assets/video/geo.mp4"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { IoMdArrowDropright } from "react-icons/io";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const Ask_Jeeves_Geo = () => {
  const navigate = useNavigate();
  const [openVideo, setOpenVideo] = useState(false);
  const [video, setVideo] = useState();
  const { setPatentLicensingModal } = useContext(PatentContext);

  const handleContactUsModal = () => {
    setPatentLicensingModal(true);
  };

  const handleOpenVideo = (title) => {
    setOpenVideo(true);
    if (title === "jeevesAction") {
      setVideo(jeevesInAction);
    } else if (title === "GeoInAction") {
      setVideo(GeoInAction);
    } else if(title === "VMI") {
      setVideo(VMI);
    } else if (title === "TheEmergencyIntelligenceConsole") {
      setVideo(EmergencyVideo);
    }
    else {
      setVideo(genevieveInAction);
    }
  };
  // bg-gradient-to-t from-slate-900 via-slate-800 to-gray-700
  // bg-gradient-to-t from-slate-900 to-slate-700
  return (
    <div>
      <div>
        <>
          <section
            className="relative w-full bg-gradient-to-t from-[#0c152b] via-[#26344b] to-[#314568]  min-h-screen
overflow-y-auto"
          >
            <div className="flex items-center justify-end p-2">
              <div className="px-2">
                <button
                  onClick={handleContactUsModal}
                  type="button"
                  className="
      group relative inline-flex items-center gap-2.5
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#51c1e9] px-3 py-3
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <TbSend size={18} />
                  <span>Drop us a line</span>
                </button>
              </div>
              <div>
                <img src={BBBlogo} />
              </div>
            </div>
            {/* 🔥 Vertical lines overlay */}
            {/* <div className="pointer-events-none absolute inset-0 bg-[repeating-linear-gradient(90deg,rgba(255,255,255,0.09),rgba(255,255,255,0.09)_3px,transparent_4px,transparent_100px)]" /> */}

            <div className="relative z-10 flex flex-col items-center justify-center px-6 text-center mt-36 sm:mt-20">
              {/* Logo */}
              <img
                src={logo}
                alt="Ask Jeeves IP"
                className="mx-auto mb-4 w-64 md:w-80 "
                loading="lazy"
              />

              {/* Heading */}
              <h2
                className="
  text-4xl md:text-6xl lg:text-7xl
  font-extrabold tracking-tight pb-3 pt-10
  text-[#83faff]
  drop-shadow-[0_2px_12px_rgba(0,0,0,0.15)]
  "
              >
                Launch<span className="text-[#c4fdff]">ing</span>{" "}
                <span className="text-white/90">Soon</span>
              </h2>

              {/* Actions */}
              {/* <div className="relative mt-14 flex flex-col flex-wrap sm:flex-row items-center justify-center gap-4 sm:gap-6"> */}
              <div className="relative mt-14 mb-12 grid grid-cols-2 xl:grid-cols-5 gap-6 w-full max-w-7xl mx-auto">
                {/* Soft glow background */}
                {/* Contact – Secondary CTA */}
                <button
                  onClick={() => handleOpenVideo("jeevesAction")}
                  type="button"
                  className="
      group relative inline-flex items-center gap-2.5
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#51c1e9] px-6 py-2.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <svg
                    className="hidden sm:block relative h-7 w-7 transition-transform duration-300 group-hover:scale-110"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 5v10l7-5-7-5z" />
                  </svg>
                  <span>Jeeves in action</span>
                </button>
                <button
                  onClick={() => handleOpenVideo("genevieveAction")}
                  type="button"
                  className="
      group relative inline-flex items-center gap-2.5
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#51c1e9] px-4 py-2.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <svg
                    className="hidden sm:block relative h-7 w-7 transition-transform duration-300 group-hover:scale-110"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 5v10l7-5-7-5z" />
                  </svg>
                  <span>Genevieve in action</span>
                </button>
                <button
                  onClick={() => handleOpenVideo("GeoInAction")}
                  type="button"
                  className="
      group relative inline-flex items-center gap-2.5
      whitespace-nowrap w-full
      rounded-xl border border-black/10
      bg-[#51c1e9] px-2 py-2.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <svg
                    className="hidden sm:block relative h-7 w-7 transition-transform duration-300 group-hover:scale-110"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 5v10l7-5-7-5z" />
                  </svg>
                  <span>The Eyes of Sovereignty</span>
                </button>
                    <button
                  onClick={() => handleOpenVideo("VMI")}
                  type="button"
                  className="
      group relative inline-flex items-center gap-0
      whitespace-nowrap
      rounded-xl border border-black/10
      bg-[#51c1e9] px-0 py-2.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <svg
                    className="hidden sm:block relative h-7 w-8 transition-transform duration-300 group-hover:scale-110"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 5v10l7-5-7-5z" />
                  </svg>
                  <span>Virtual  Mobile Infrastructure </span>
                </button>

                 
                <Menu as="div" className="relative inline-block">
                  <MenuButton
                    className="inline-flex w-full justify-center group  group relative items-center gap-2 whitespace-nowrap pl-7
       rounded-xl border border-black/10
      bg-[#51c1e9] px-6 py-3.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer"
                  >
                    Press Release
                    <ChevronDownIcon
                      aria-hidden="true"
                      className="-mr-1 size-5 text-gray-400"
                    />
                  </MenuButton>

                  <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md  bg-[#51c1e9]/100 outline-[#51c1e9]/100 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                  >
                    <div className="py-1">
                      <MenuItem>
                        <a
                          href="https://investorshangout.com/kenneth-ohanlon-pioneering-the-future-of-digital-innovation-509688-/"
                          target="_blank"
                          className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden
                    hover:bg-white/15"
                        >
                          Pioneering the Future of Digital Innovation -
                          Investors Hangout
                        </a>
                      </MenuItem>
                      <MenuItem>
                        <a
                          href="https://sg.finance.yahoo.com/news/inner-circle-acknowledges-kenneth-ohanlon-172800269.html?guccounter=1"
                          target="_blank"
                          className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                        >
                          The Inner Circle acknowledges Kenneth O'Hanlon
                        </a>
                      </MenuItem>
                      <MenuItem>
                        <a
                          href="https://feature.marquiswhoswho.com/MWW_WSJ_Western_February12_2026"
                          target="_blank"
                          className="block px-1 py-2 text-sm text-white data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden hover:bg-white/15"
                        >
                          Marquis who's who
                        </a>
                      </MenuItem>
                    </div>
                  </MenuItems>
                </Menu>
              </div>
              <div className="flex gap-2">
                    <button
                  onClick={() => handleOpenVideo("TheEmergencyIntelligenceConsole")}
                  type="button"
                  className="
      group relative  items-center gap-2.5
      whitespace-nowrap
       col-span-2 xl:col-auto flex justify-center
      rounded-xl border border-black/10
      bg-[#51c1e9] px-16 py-3.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <svg
                    className="hidden sm:block relative h-7 w-7 transition-transform duration-300 group-hover:scale-110"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M8 5v10l7-5-7-5z" />
                  </svg>
                  <div className="flex justify-center items-center gap-2">
                    <span>The Emergency Intelligence Console.</span>
                  </div>
              </button>  
              <button
                  onClick={() => navigate("/seven-pillars")}
                  type="button"
                  className="
      group relative  items-center gap-2.5
      whitespace-nowrap
       col-span-2 xl:col-auto flex justify-center
      rounded-xl border border-black/10
      bg-[#51c1e9] px-16 py-3.5
      text-sm font-semibold text-black
      backdrop-blur-md
      shadow-[0_6px_20px_rgba(0,0,0,0.12)]
      transition-all duration-300
      hover:-translate-y-0.5 hover:bg-[#51c1e9e8]
      hover:shadow-[0_14px_35px_rgba(0,0,0,0.18)]
      focus:outline-none cursor-pointer
    "
                >
                  <div className="flex justify-center items-center gap-2">
                    <span>O'Hanlon Center of Excellence.</span>
                  </div>
              </button>
              </div>
           
            </div>
            
            <div className="absolute w-full font-semibold  bottom-0 bg-white/15">
              <div className="flex justify-center  items-center">
                <span className="py-2 text-white">
                  © 2026 Ask Jeeves Geo. All Rights Reserved
                </span>
              </div>
            </div>
          </section>
        </>
        {openVideo && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={() => setOpenVideo(false)}
          >
            <div
              className="relative mx-4 w-full max-w-6xl rounded-2xl border border-[#121315]/40 bg-[#121315]/30 backdrop-blur-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close */}
              <button
                onClick={() => setOpenVideo(false)}
                aria-label="Close video"
                className="absolute -right-4 -top-4 flex h-9 w-9 items-center justify-center rounded-full bg-[#1281b6] text-white font-bold shadow-lg transition hover:scale-105 cursor-pointer"
              >
                ✕
              </button>

              {/* Video */}
              <video
                src={video}
                controls
                autoPlay
                className="w-full rounded-2xl"
              />
            </div>
          </div>
        )}
        <ContactUsModal />
      </div>
    </div>
  );
};

export default Ask_Jeeves_Geo;
